export const environment = {
    production: false,
    apiUrl: 'https://api.cdr.qual.cawita.com',
    assetUrl: 'https://assets.cdr.qual.cawita.com',
    customerSpaceUrl: 'https://share.cdr.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};